var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    loading: false,
    loaded: false,
    error: null,
    serviceTypes: []
};
var serviceTypesSlice = createSlice({
    name: 'serviceTypes',
    initialState: initialState,
    reducers: {
        getServiceTypes: function (state) {
            state.loading = true;
            state.loaded = false;
            state.error = null;
        },
        getServiceTypesSucceeded: function (state, action) {
            state.loading = false;
            state.loaded = true;
            // Reformat service types into expected format
            var types = action.payload ? action.payload.map(function (serviceType) {
                return {
                    key: serviceType.uuid,
                    label: serviceType.name,
                    typeFilter: serviceType.uuid,
                };
            }) : [];
            state.serviceTypes = types;
        },
        getServiceTypesFailed: function (state, action) {
            state.loading = false;
            state.loaded = true;
            state.error = action.payload;
        }
    },
});
export var getServiceTypes = (_a = serviceTypesSlice.actions, _a.getServiceTypes), getServiceTypesSucceeded = _a.getServiceTypesSucceeded, getServiceTypesFailed = _a.getServiceTypesFailed;
export default serviceTypesSlice.reducer;
